<template>
  <div>
    <div class="search">
      <b-form-group
        id="input-group-4"
        label="Selecione uma obra"
        label-for="input-x"
      >
        <b-form-select
          id="input-x"
          v-model="obraSelecionada"
          type="text"
          placeholder="Enter items"
          required
        >
          <b-form-select-option
            v-for="obra in obras"
            :key="obra._id"
            :value="obra"
          >
            {{ obra.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Pesquisar Insumo"
        label-for="filter"
        class="flex-grow-1"
      >
        <b-input-group>
          <b-form-input
            v-model="filter.code"
            placeholder="Digite o código do insumo aqui..."
            class="flex-grow-1"
          />
          <b-input-group-append>
            <b-button variant="primary" @click="search">Pesquisar</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <!-- <div style="display: flex; flex-direction: column;  align-items: center;">
        <label for="switchControlar">
          Ajuste automático de estoque mínimo:
        </label>
        <b-form-checkbox switch />
      </div> -->
    </div>
    <b-table
      striped
      hover
      responsive="sm"
      borderless
      bordered
      outlined
      small
      :items="lowStocks"
      :fields="lowStockFields"
      :per-page="perPage"
      :current-page="page"
      show-empty
      empty-text="Não há registros no momento"
    >
      <template v-slot:cell(estoqueInsumo)="row">
        <span v-show="row.item.descricao_pai !== undefined"
          >{{ row.item.descricao_pai }} <br
        /></span>
        {{ row.item.insumo !== undefined ? row.item.insumo.codigo : '' }}
        -
        {{ row.item.insumo !== undefined ? row.item.insumo.descricao : '' }}
      </template>
      <template v-slot:cell(editar)="row">
        <div class="btn-group mb-2">
          <button
            v-b-tooltip.hover
            title="Editar quantidade"
            type="button"
            class="btn btn-light"
            @click="getStockById(row.item)"
          >
            <b-icon icon="pencil-square" />
          </button>
        </div>
      </template>
      <template v-slot:cell(controlar)="row">
        <b-form-checkbox
          v-model="row.item.insumo.estoqueBaixoAutomatico"
          switch
          @change="changeEstoqueAutomatico(row.item)"
        />
      </template>
    </b-table>
    <b-pagination
      v-if="lowStocks.length"
      v-model="page"
      size="md"
      :total-rows="rows"
      :per-page="perPage"
    />
    <loading :active.sync="isLoading" color="#111d5e" :can-cancel="false" />
  </div>
</template>

<script>
import EstoqueModel from '@/src/model/estoque.model'
import DashboardService from '@/src/services/serviceDasboard'
import StockService from '@/src/services/serviceEstoqueObra'
import AlertMixin from '@/src/mixins/alertMixin'
import Loading from 'vue-loading-overlay'
import serviceObra from '@/src/services/serviceObra'
import InsumoService from '@/src/services/serviceInsumoObra'

export default {
  components: { Loading },
  mixins: [AlertMixin],
  data() {
    return {
      lowStocks: [],
      obras: [],
      obraSelecionada: {},
      lowStockFields: EstoqueModel.lowStockFields,
      page: 1,
      perPage: 10,
      rows: 0,
      isLoading: false,
      filter: {
        code: null,
      },
    }
  },

  async created() {
    const promises = [this.getLowStocks({}), this.listaObras()]
    await Promise.all(promises)
  },

  methods: {
    search() {
      this.getLowStocks({
        filter: { code: this.filter.code, obra: this.obraSelecionada },
      })
    },

    async changeEstoqueAutomatico(estoque) {
      await this.changeEstoqueBaixoAutomaticoById(estoque)
    },

    async getStockById({ _id }) {
      this.isLoading = true

      try {
        const { data } = await StockService.getOne(_id)

        this.$emit('edit-stock', data)
      } catch (error) {
        this.errorMessage(
          `Erro ao buscar Estoque: ${error.response.data.error.message}`
        )
      } finally {
        this.isLoading = false
      }
    },

    async getLowStocks({ filter = this.filter }) {
      let { code, obra } = filter
      this.isLoading = true

      if (obra) {
        obra = obra._id
      }

      try {
        const { filial } = this.$store.state
        const {
          data: { data },
        } = await DashboardService.listLowStock(filial, code, obra)

        const { results } = data

        this.lowStocks = results
        this.rows = results.length
      } catch (error) {
        this.errorMessage(
          `Erro ao buscar Estoques Baixos: ${error.response.data.error.message}`
        )
      } finally {
        this.isLoading = false
      }
    },

    async listaObras() {
      try {
        let {
          data: { data },
        } = await serviceObra.list('filial', this.$store.state.filial)

        this.obras = data

        if (
          this.obraSelecionada !== undefined &&
          this.obraSelecionada._id !== undefined
        ) {
          let exitItem = this.obras.find(
            (el) => el._id === this.obraSelecionada._id
          )

          if (exitItem !== undefined) {
            this.obraSelecionada = exitItem
          }
        }
      } catch (error) {
        this.errorMessage('Erro ao Buscar Obras')
      }
    },

    async changeEstoqueBaixoAutomaticoById(estoque) {
      this.isLoading = true
      try {
        await InsumoService.updateAutomaticStock(
          estoque.insumo._id,
          estoque.insumo.estoqueBaixoAutomatico
        )

        this.successMessage('Atualizado com sucesso')
        window.location.reload()
      } catch (error) {
        this.errorMessage(
          `Erro ao alterar a atualização de estoque automática: ${
            error.response.data.error.message
          }`
        )
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style>
.search {
  display: flex;
  gap: 10px;
}

.search > * {
  flex: 1;
  flex-basis: 50%;
}
</style>
